import { render, staticRenderFns } from "./CompanyReportTabTaken.vue?vue&type=template&id=57f380a8"
import script from "./CompanyReportTabTaken.vue?vue&type=script&lang=js"
export * from "./CompanyReportTabTaken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports